const DateUtils = require('utils/DateUtils'),
    {t} = require('services/i18nextWrapper'),
    OrderUtils = require('utils/OrderUtils'),
    NumberUtils = require('utils/NumberUtils'),
    React = require('react'),
    DashboardServiceCache = require('services/DashboardServiceCache'),
    BrewhouseStore = require('stores/BrewhouseStore'),
    BeerStyleStore = require('stores/BeerStyleStore'),
    OrderStore = require('stores/OrderStore'),
    SessionStore = require('stores/SessionStore'),
    InventoryStore = require('stores/InventoryStore'),
    DashboardModalStore = require('stores/DashboardModalStore'),
    TankStore = require('stores/TankStore'),
    DashboardModalEl = require('components/DashboardModal/DashboardModalEl'),
    DashboardLayoutStore = require('stores/DashboardLayoutStore'),
    DashboardModalUtils = require('components/DashboardModal/DashboardModalUtils'),
    ChronologycStore = require('stores/ChronologycStore'),
    DashboardModalTaskCollapsible = require('components/DashboardModal/DashboardModalTask/DashboardModalTaskCollapsible'),
    {
        SINGLE_TASK,
        DATE_FORMAT,
        DATE_FORMAT_DISPLAY_COMBO_DAY,
        TYPE_TANK_FERMENTER,
        TYPE_TANK_BRITE_TANK,
        TYPE_TANK_BREW_HOUSE
    } = require('constants/AppConstants'),
    moment = require('moment'),
    {
        getNonSelectedMenuItem,
        toConcreteTask,
        getStyleBeer,
        setTaskIds
    } = require('components/DashboardModal/DashboardModalUtils'),
    ContentUtils = require('utils/ContentUtils'),

    {some, map, filter, find, countBy} = require('lodash/collection'),
    {flatten, concat, findIndex, uniqBy, head} = require('lodash/array'),
    {cloneDeep, clone} = require('lodash/lang'),
    {assign, merge} = require('lodash/object'),
    get = require('lodash/object').get,
    set = require('lodash/object').set;

//TODO: no way to relax no-unused-vars from es-lint rule
React.createClass({
    render(){
    }
});

function _recalculateLayout(nextState) {
    const ordersFromRange = OrderUtils.getOrderByRange(nextState.fromDate, nextState.toDate);
    // convert orders to position objects
    const positionOrders = flatten(map(ordersFromRange, order => OrderUtils.convertOrderToPositions(order, ChronologycStore.getCurrentFrom(), null, true)));
    DashboardModalStore.setCurrentLayout(positionOrders);
    return nextState;
}

function getNewModalState(props, isBHAllowed, isFVAllowed, isBTAllowed, currentSection) {
    const currentTankClicked = get(props, 'preDefinedOrder.tankSelected') || get(props, 'tankSelected');

    let nextState = _getInitialState(props, currentSection, currentTankClicked);
    nextState = _initMenuItems(nextState, currentTankClicked);
    nextState = _updateVolume(nextState, ContentUtils.getNumber(get(nextState, 'tankSelected.volume', 0)));
    nextState = _sinchronizedInnerOuterFromToDates(nextState);
    nextState = _someProductAlreadyConfirmed(nextState);

    return nextState;
}

function _someProductAlreadyConfirmed(nextState) {
    const products = OrderUtils.getAllProductsFromOrder(nextState.order);
    nextState.isSomeProductAlreadyConfirmed = some(products, product => {
        return get(product, 'isConfirmed');
    });
    return nextState;
}

function _getInitialState(props, currentSection, currentTankClicked) {
    let nextState = {};
    const predefinedOrder = get(props, 'preDefinedOrder');

    // define default tank selected
    const tankSelected = get(props, 'tankSelected');
    const tankSelectedType = get(tankSelected, 'type');
    const isCurrentSectionSameAsTankSelectedType = tankSelectedType === currentSection;
    if (isCurrentSectionSameAsTankSelectedType) {
        nextState.tankSelected = tankSelected;
    }

    // define default brewhouse batchs
    if (currentSection === 'BH') {
        nextState = set(nextState, 'order.batchs', null);
    } else {
        nextState = set(nextState, 'order.batchs', props.isBHAllowed ? [] : null);
    }

    DashboardModalStore.setCurrentLayout(null);
    nextState.orderVolumePristine = ContentUtils.getNumber(get(currentTankClicked, 'volume'));
    nextState.currentSection = currentSection;
    nextState.fromDate = props.initFromDate;
    nextState.toDate = props.initFromDate;
    nextState.isNewModal = true;
    nextState.isNewModal = true;
    nextState.toDateMessageError = null;
    nextState.fromDateMessageError = null;
    nextState.tankTypeMessageError = null;
    nextState.styleBeerSelectedIndex = null;
    nextState.styleBeerSelected = null;
    nextState.tankMessageError = null;
    nextState.shouldNeedValidate = true;
    nextState.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error');
    nextState.batchNumber = predefinedOrder.batchNumber;
    nextState.forceDisableToggle = false;

    return nextState;
}

function getExistingModalState(oldState, isBHAllowed, orderDateClicked) {
    let nextState = cloneDeep(oldState);
    const existingOrder = get(nextState, 'order');
    const tankType = ContentUtils.getTankTypeConfiguration(get(existingOrder, 'singleTank.type'));
    const typeTask = get(tankType, 'tankType');

    nextState.order = existingOrder;
    nextState.tankSelected = existingOrder.singleTank;
    nextState.fromDate = DateUtils.toDate(existingOrder.fromDate);
    nextState.toDate = DateUtils.toDate(existingOrder.toDate);
    nextState.singleTasks = setTaskIds(existingOrder.singleTasks, typeTask);
    nextState.orderVolume = ContentUtils.getNumber(existingOrder.volume);
    nextState.orderVolumePristine = ContentUtils.getNumber(existingOrder.volume);
    nextState.dataClicked = orderDateClicked;
    nextState.toDateMessageError = null;
    nextState.fromDateMessageError = null;
    nextState.tankTypeMessageError = null;
    nextState.tankMessageError = null;
    nextState.isNewModal = false;
    nextState.isSingle = true;
    nextState.commentOrder = existingOrder.comment;
    nextState.shouldNeedValidate = true;
    nextState.batchNumber = existingOrder.batchNumber;

    nextState = _recalculateLayout(nextState);
    nextState = _initMenuItems(nextState, existingOrder.singleTank, get(existingOrder, 'singleTank.type'));
    nextState = _updateExistingBeerStyle(nextState, existingOrder);

    return nextState;
}

function _hydratedTasksWithProducts(nextState) {
    if (SessionStore.isFullPaidVersion()) {
        const order = get(nextState, 'order');
        const beerStyleId = get(nextState, 'styleBeerSelected.id');
        nextState.singleTasks = InventoryStore.hydrateTaskWithProducts(nextState.singleTasks, beerStyleId);
        order.batchs = InventoryStore.hydrateTaskWithProducts(order.batchs, beerStyleId);
    }
    return nextState;
}

function initializeSingleTasksEl(currentListedTaskTypeSelected, self) {
    switch (currentListedTaskTypeSelected) {
        case TYPE_TANK_FERMENTER:
            return _initializeOrderTasks(
                self.state.fromDate,
                self.state.toDate,
                self.state.singleTasks,
                self.state.process,
                DashboardServiceCache.getFermenterIcons(),
                TYPE_TANK_FERMENTER,
                self.state.dataClicked,
                self._onBlurLabelOrDescription,
                self._onChangeTask,
                self._onChangeProcess,
                self._onChangeProducts,
                self._onChangeAmountItem,
                self._onChangeVolumeItem,
                self._onChangeAmountInLocation,
                self._onConfirmProduct,
                self
            );
        case TYPE_TANK_BRITE_TANK:
            return _initializeOrderTasks(
                self.state.fromDate,
                self.state.toDate,
                self.state.singleTasks,
                self.state.process,
                DashboardServiceCache.getPackagingIcons(),
                TYPE_TANK_BRITE_TANK,
                self.state.dataClicked,
                self._onBlurLabelOrDescription,
                self._onChangeTask,
                self._onChangeProcess,
                self._onChangeProducts,
                self._onChangeAmountItem,
                self._onChangeVolumeItem,
                self._onChangeAmountInLocation,
                self._onConfirmProduct,
                self
            );
        case TYPE_TANK_BREW_HOUSE:
            return _initializeOrderTasks(
                self.state.fromDate,
                self.state.toDate,
                self.state.singleTasks,
                self.state.process,
                DashboardServiceCache.getBrewhouseIcons(),
                TYPE_TANK_BREW_HOUSE,
                self.state.dataClicked,
                self._onBlurLabelOrDescription,
                self._onChangeTask,
                self._onChangeProcess,
                self._onChangeProducts,
                self._onChangeAmountItem,
                self._onChangeVolumeItem,
                self._onChangeAmountInLocation,
                self._onConfirmProduct,
                self
            );
    }
}

function _initializeOrderTasks(fromDate,
                               toDate,
                               singleTasks,
                               orderProcess,
                               tasks,
                               tankType,
                               dateTaskFocus,
                               onBlurLabelOrDescription,
                               onChangeTaskConsumer,
                               onChangeProcess,
                               onChangeProducts,
                               onChangeAmountItem,
                               onChangeVolumeItem,
                               onChangeAmountInLocation,
                               onConfirmProduct,
                               self) {
    let indexDay = -1,
        date,
        dateTask,
        taskEl = [],
        fromDateText,
        toDateText,
        existingTask,
        existingTasks,
        dateTaskFocusText = dateTaskFocus ? DateUtils.toDateText(dateTaskFocus) : null,
        tankTypeClassName = 'modal-order-task-list-item-label col-xs-2';

    if (DateUtils.isAfter(DateUtils.toDateText(fromDate), DateUtils.toDateText(toDate))) {
        return;
    }

    const isEditMode = get(self, 'state.isNewModal') === false || get(self, 'state.isNewModal') === undefined;
    const shouldBeDisabled = !SessionStore.isAbleToEditAllWithoutDates();

    const existSingleTask = fromDate && toDate && singleTasks;

    if (existSingleTask) {
        fromDateText = DateUtils.toDateText(fromDate);
        toDateText = DateUtils.toDateText(toDate);

        do {
            indexDay++;
            date = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT_DISPLAY_COMBO_DAY);
            dateTask = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT);
            existingTasks = filter(singleTasks, task => task.date === dateTask && task.tankType === tankType);

            const existingProcess = DashboardServiceCache.getProcessByType(tankType);

            // add especial class name to center the focus an specific task, this happen only into edit mode, when double click from dashboard into one task.
            if (dateTaskFocusText === dateTask) {
                tankTypeClassName += ' is-focused';
            }

            if (existingTasks && existingTasks.length > 0) {
                existingTask = existingTasks[0];

                if (!existingTask.tankType) {
                    // in chase that `existingTask` don't have tankType, we take this from current TankType of Tank selected.
                    existingTask.tankType = get(self, 'state.singleTank.type');
                }
                // load the rest of the menu list of task, which is the same task type of `existingTask`. In order to
                // allow each task have their own list of item tasks, just in case if want to change to another of the same type of task.
                if (!existingTask.tasks) {
                    existingTask.tasks = DashboardServiceCache.getTasksByType(existingTask.tankType);
                }

                // assign proper payload to existing task order
                existingTask.payload = getPayload(existingTask, tasks);

                // Create and ID to later can use to Order Process
                existingTask.taskId = `${dateTask}_${existingTask.tankType}`;
                existingTask.taskIdByTaskType = `${get(ContentUtils.getTankTypeConfiguration(existingTask.tankType), 'postFixTaskType')}_${dateTask}`;
                existingTask.sectionType = existingTask.tankType;

                // add default end hour product
                existingTask = OrderUtils.setDefaultEndHourToProductsOfTask(existingTask, dateTask);

                // custom key
                const keyAttr = `key-${indexDay}-${dateTask}-${tankType}-${existingTask.taskId}`;

                // Add src task in order to avoid calculate
                existingTask.imageSrc = get(find(tasks, task => task.displayName === existingTask.name), 'src');

                // hydrate with all field of each products
                existingTask = InventoryStore.hydrateProductWithDefaultAmountAndVolume(existingTask);

                taskEl.push((
                    React.createElement(DashboardModalTaskCollapsible, {
                        onChangeProcess: onChangeProcess, 
                        orderProcess: orderProcess, 
                        onChangeProducts: onChangeProducts, 
                        onChangeAmountItem: onChangeAmountItem, 
                        onChangeAmountInLocation: onChangeAmountInLocation, 
                        onChangeVolumeItem: onChangeVolumeItem, 
                        onConfirmProduct: onConfirmProduct, 
                        date: date, 
                        order: self.state.order, 
                        isEditMode: isEditMode, 
                        uniqueId: keyAttr, 
                        existingProcess: existingProcess, 
                        indexDay: indexDay, 
                        shouldBeDisabled: shouldBeDisabled, 
                        showDeleteIcon: true, 
                        typeTask: existingTask.tankType, 
                        typeTaskClassName: tankTypeClassName, 
                        existingTask: existingTask, 
                        tasks: existingTask.tasks, 
                        onChangeTaskType: onChangeTaskConsumer.bind(self, existingTask.tasks, existingTask, existingTask.tankType, dateTask), 
                        onBlurLabel: self._onChangeName.bind(self, existingTask, tankType, dateTask), 
                        onBlurDescription: self._onChangeNote.bind(self, existingTask, tankType, dateTask), 
                        onToggleExpand: self._onToggleExpand.bind(self, existingTask)}
                    )
                ));
            } else {
                // custom key
                const keyAttr = `key-${indexDay}-${dateTask}-${tankType}-${get(existingTasks, 'length', 0)}`;

                existingTask = {
                    payload: 1,
                    imageSrc: '',
                    taskId: `${dateTask}_${tankType}`,
                    date: dateTask
                };

                taskEl.push((
                    React.createElement(DashboardModalTaskCollapsible, {
                        onChangeProcess: onChangeProcess, 
                        orderProcess: orderProcess, 
                        onChangeProducts: onChangeProducts, 
                        onChangeAmountItem: onChangeAmountItem, 
                        onChangeAmountInLocation: onChangeAmountInLocation, 
                        onConfirmProduct: onConfirmProduct, 
                        onChangeVolumeItem: onChangeVolumeItem, 
                        date: date, 
                        order: self.state.order, 
                        isEditMode: isEditMode, 
                        uniqueId: keyAttr, 
                        existingTask: existingTask, 
                        existingProcess: existingProcess, 
                        indexDay: indexDay, 
                        shouldBeDisabled: shouldBeDisabled, 
                        showDeleteIcon: false, 
                        typeTask: tankType, 
                        typeTaskClassName: tankTypeClassName, 
                        tasks: tasks, 
                        onChangeTaskType: onChangeTaskConsumer.bind(self, tasks, existingTask, tankType, dateTask), 
                        onBlurLabel: self._onChangeName.bind(self, existingTask, tankType, dateTask), 
                        onBlurDescription: self._onChangeNote.bind(self, existingTask, tankType, dateTask), 
                        onToggleExpand: self._onToggleExpand.bind(self, existingTask)}
                    ))
                );
            }
        } while (moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT) !== toDateText);
    }

    return taskEl;
}

function onChangeFromDate(oldState, fromDate, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState.offsetY = ChronologycStore.getYFromDate(DateUtils.toDateText(fromDate)) - ChronologycStore.getYFromDate(DateUtils.toDateText(oldState.fromDate));
    nextState.fromDate = fromDate;
    if (nextState.order) {
        // we need to keep `state.order` up-to in order to perform properly the following validation.
        nextState.order.fromDate = DateUtils.toDateText(fromDate);
    }
    nextState = _recalculateLayout(nextState);
    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
    nextState = _recalculateSingleOrderTasks(oldState, nextState);
    nextState = _sinchronizedInnerOuterFromToDates(nextState); // to avoid data issues
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues

    nextState = merge(nextState, isValidForm(nextState).messagesError);
    nextState.shouldNeedValidate = true;

    return nextState;
}

function onChangeToDate(oldState, toDate, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState.toDate = toDate;
    nextState.shouldNeedValidate = true;
    if (nextState.order) {
        // we need to keep `state.order` up-to date before submit in order to perform properly the following validation.
        nextState.order.toDate = DateUtils.toDateText(toDate);
    }
    nextState = _recalculateLayout(nextState);
    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
    nextState = _sinchronizedInnerOuterFromToDates(nextState);
    nextState = _recalculateSingleOrderTasks(oldState, nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues

    nextState = merge(nextState, isValidForm(nextState).messagesError);

    return nextState;
}

function onChangeFromDateEditMode(oldState, fromDate, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState.fromDate = fromDate;
    if (nextState.order) {
        // we need to keep `state.order` up-to in order to perform properly the following validation.
        nextState.order.fromDate = DateUtils.toDateText(fromDate);
    }
    nextState = _recalculateLayout(nextState);
    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
    nextState = _recalculateSingleOrderTasks(oldState, nextState);
    nextState = _sinchronizedInnerOuterFromToDates(nextState); // to avoid data issues
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues

    nextState = merge(nextState, isValidForm(nextState).messagesError);
    nextState.shouldNeedValidate = true;

    return nextState;
}

function onChangeToDateEditMode(oldState, toDate, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState.toDate = toDate;
    nextState.shouldNeedValidate = true;
    if (nextState.order) {
        // we need to keep `state.order` up-to date before submit in order to perform properly the following validation.
        nextState.order.toDate = DateUtils.toDateText(toDate);
    }
    nextState = _recalculateLayout(nextState);
    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
    nextState = _recalculateSingleOrderTasks(oldState, nextState);
    nextState = _sinchronizedInnerOuterFromToDates(nextState);    // to avoid data issues
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues

    nextState = merge(nextState, isValidForm(nextState).messagesError);

    return nextState;
}

function onChangeTank(oldState, menuItem) {
    let nextState = clone(oldState);
    nextState = _updateTankSelected(nextState, menuItem);
    nextState = merge(nextState, isValidForm(nextState).messagesError);

    return nextState;
}

function onChangeTankEditMode(oldState, menuItem) {
    let nextState = clone(oldState);
    nextState = _updateTankSelected(nextState, menuItem);
    nextState.shouldNeedValidate = true;
    nextState = merge(nextState, isValidForm(nextState).messagesError);

    return nextState;
}

function onDeleteTask(singleTasks, dateTask) {
    const nextState = {
        singleTasks: filter(singleTasks, function (task) {
            return task.date !== dateTask;
        })
    };
    nextState.shouldNeedValidate = false;

    return nextState;
}


/**
 * Reset all state of the modal.
 * @argument {HTMLElement} self the context that was invoke
 * @private
 */
function cleanModal(self) {
    self.setState(Object.assign(
        {},
        {
            singleOrder: null,
            dataClicked: null,
            singleTasks: [],
            batchs: [],
            isSuggested: false,
            styleBeerSelected: null,
            singleTankIndex: null,
            isSingleMode: false,
            order: null,
            singleTank: null,
            shouldNeedValidate: false,
            isBHAllowed: true,
            isFVAllowed: true,
            isBTAllowed: true,
            currentSection: null
        },
        getInitialStateErrorMessages()
    ));
}

function onChangeBeerStyle(oldState, menuItem, currentSection, isBHAllowed) {
    let nextState = cloneDeep(oldState) || {};
    nextState.styleBeerTextColor = 'inherit';
    nextState.styleBeerSelected = menuItem;
    nextState.styleBeerSelectedIndex = menuItem.payload;
    nextState.shouldNeedValidate = true;
    nextState.isBeerStyleAlreadyDefined = true;
    nextState = set(nextState, 'order.isSingle', true);

    nextState = _recalculateFromToDate(nextState, currentSection);
    nextState = _recalculateLayout(nextState);
    nextState = _updateTankSelected(nextState, nextState.singleTank);
    nextState = _initInitialTasks(nextState);
    nextState = _initNewTasksWithConfiguration(nextState, currentSection);
    nextState = _sinchronizedInnerOuterFromToDates(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = _hydratedTasksWithProducts(nextState);
    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
    nextState = _updateOrderWithScopeEstimation(nextState); // the icons colors inventory

    nextState = merge(nextState, isValidForm(nextState).messagesError);

    return nextState;
}

function _updateOrderWithScopeEstimation(nextState) {
    const ordersWithInventoryScope = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation([nextState.order, ...OrderStore.getOrders()]);
    nextState.order = ordersWithInventoryScope.find(order => order.id === nextState.order.id);
    return nextState;
}

function onChangeVolume(oldState, newVolume, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState = _updateVolume(nextState, newVolume);
    if (nextState.isNewModal) {
        nextState = _recalculateSingleTankByVolume(nextState);
    }
    nextState = _recalculateLayout(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = merge(nextState, isValidForm(nextState).messagesError);
    nextState.shouldNeedValidate = true;
    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);

    return nextState;
}

function onChangeVolumeNew(oldState, newVolume, isBHAllowed) {
    let nextState = cloneDeep(oldState);
    nextState = _updateVolume(nextState, newVolume);
    const currentSection = get(nextState, 'currentSection');

    nextState = _recalculateSingleTankByVolume(nextState);
    nextState = _recalculateLayout(nextState);
    nextState = _initInitialTasks(nextState);
    nextState = _initNewTasksWithConfiguration(nextState, currentSection);
    nextState = _sinchronizedInnerOuterFromToDates(nextState);
    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
    nextState = _hydratedTasksWithProducts(nextState);
    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
    nextState = merge(nextState, isValidForm(nextState).messagesError);
    nextState.shouldNeedValidate = true;
    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);

    return nextState;
}

function onChangeTask(targetValue, existingSingleTask, dateTask, field) {
    let newTask = find(existingSingleTask, (task) => task.date === dateTask);
    let nextState = {};

    if (!newTask) {
        newTask = DashboardModalUtils.toEmptyTask(dateTask);
        existingSingleTask.push(newTask);
    }

    newTask[field] = targetValue;
    nextState.singleTasks = ContentUtils.replace(existingSingleTask, newTask, 'date');
    return nextState;
}

/**
 * Initialize default task.
 * @param {Object} nextState
 * @private
 * @returns {Object}
 */
function _initInitialTasks(nextState) {
    const singleTasks = [];
    nextState.singleTasks = singleTasks;
    return nextState;
}


function getPayload(existingTask, tasks) {
    let payload = findIndex(tasks, task => task.name === existingTask.name);
    if (payload > -1) {
        return payload + 1;
    }
    return findIndex(tasks, task => task.displayName === existingTask.name) + 1;
}

function _onChangeTaskType(tasks, oldItemSelected, typeTask, dateTask, state, evt, itemSelected) {
    let newTask = {},
        newTasks = [],
        nextState = {};

    const displayNameIcon = get(itemSelected.itemModel, 'id') === 1 ? 'no-icon' : (get(evt, 'text') || get(itemSelected, 'name') || get(itemSelected, 'text') || get(evt, 'target.value'));
    const currentIcon = DashboardServiceCache.findIconByDisplayName(displayNameIcon);
    // check if exist some existing task before
    // create a new one from scratch
    newTask = findExistingTask(dateTask, state, typeTask);
    if (newTask === undefined) {
        newTask = {};
        newTask.date = dateTask;
        newTask.description = get(itemSelected, 'description') || '',
        newTask.label = get(itemSelected, 'label') || '',
        newTask.tankType = typeTask;
    }

    if (ContentUtils.isEmptyArray(newTask.products)) {
        newTask.isNewProduct = true;
    }

    // clean older products
    newTask.products = [];

    // set the new task icon information
    newTask.displayName = displayNameIcon;
    newTask.name = get(currentIcon, 'name') || 'no-icon';
    newTask.type = SINGLE_TASK;
    newTask.tankType = typeTask;
    newTask.tasks = tasks;

    if (oldItemSelected) {
        newTasks = filter(state.singleTasks, packagingTask => get(oldItemSelected, 'date') !== packagingTask.date);
    } else {
        newTasks = state.singleTasks;
    }

    newTask = head(InventoryStore.hydrateTaskWithProducts([newTask], get(state, 'styleBeerSelected.id')));
    newTasks.push(newTask);

    nextState = {singleTasks: newTasks};
    state.order.singleTasks = ContentUtils.replaceByAttributes(state.order.singleTasks, newTask, 'date');
    nextState.shouldNeedValidate = false;
    
    state.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(
      state.order,
      DashboardServiceCache.getVendorItems()
    );

    return assign(state, nextState);
}

function findExistingTask(date, state) {
    return find(get(state, 'singleTasks'), task => task.date === date);
}

function _updateExistingBeerStyle(nextState, existingOrder) {
    const styleBeerSelected = getStyleBeer(nextState.beerStyleMenuItems, existingOrder);
    nextState.styleBeerSelectedIndex = styleBeerSelected.index;
    nextState.styleBeerSelected = styleBeerSelected.item;

    return nextState;
}

function _sinchronizedInnerOuterFromToDates(nextState) {
    nextState = set(nextState, 'order.fromDate', DateUtils.toDateText(nextState.fromDate));
    nextState = set(nextState, 'order.toDate', DateUtils.toDateText(nextState.toDate));

    return nextState;
}

function _updateVolume(nextState, newVolume) {

    if (NumberUtils.containSomeNotNumber(newVolume)) {
        nextState = set(nextState, 'messagesError.volumenTankMessageError', t('notification_volume_must_be_a_number'));
        nextState.orderVolume = newVolume;
        return nextState;
    } else {
        nextState = set(nextState, 'messagesError.volumenTankMessageError', '');
    }

    nextState.orderVolume = ContentUtils.getNumber(newVolume);

    if (!nextState.orderVolume) { // could be --> 0 || null || undefined
        nextState = set(nextState, 'order.volume', 0);
        nextState.orderVolume = 0;
    } else {
        nextState = set(nextState, 'order.volume', nextState.orderVolume);
    }

    return nextState;
}

function _recalculateSingleTankByVolume(state) {
    const tankVolume = ContentUtils.getNumber(get(state, 'singleTank.volume'));
    const orderVolume = ContentUtils.getNumber(state.orderVolume);

    if (state.singleTank && tankVolume < orderVolume) {
        let nextState = cloneDeep(state);
        const singleTankNext = TankStore.getNextSingleTankAvailable(nextState.fromDate, nextState.toDate, nextState.orderId, nextState.orderVolume, get(nextState, 'tankSelected.type'), DashboardModalStore.getCurrentLayout());

        if ((ContentUtils.getNumber(get(singleTankNext, 'volume'))) >= ContentUtils.getNumber(state.orderVolume)) {
            // enter here means that we sure that is time to change the tank available, because found another tank more suitable
            nextState = _updateTankSelected(nextState, singleTankNext);
        }
        return nextState;
    }

    return state;
}

function _recalculateBrewhouse(oldState, nextState, isBHAllowed) {
    const isFVAllowed = nextState.currentSection === 'FV';
    const isBTAllowed = nextState.currentSection === 'BT';

    if (isBHAllowed === undefined) {
        isBHAllowed = get(nextState, 'order.batchs.length') > 0;
    }

    if (countBy([isBHAllowed, isFVAllowed, isBTAllowed], num => num).false === 2 && get(nextState, 'order.batchs.length', 0) === 0) {
        // enter here means only one toggle is 'ON', so is just a single without brewhouse section
        return BrewhouseStore.cleanBrewhouse(nextState);
    }

    if (!isBHAllowed) {
        // enter here means that the toggle brehouse is off, so is not needed to show brewing tab neither update any batch
        return BrewhouseStore.cleanBrewhouse(nextState);
    }

    if (!nextState.orderVolume) { // could be zero, null or undefined
        // enter here is a new order that should not have batchs
        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array [] in order to still show the brewing tab
    }

    if (nextState.orderVolume > 0) {
        // compare old fromDate to new fromDate in order to know the offset
        const offsetDays = DateUtils.getDaysBetween(oldState.fromDate || nextState.fromDate, nextState.fromDate);

        // enter here means that the order have volume, so need to calculate the batch needed for this volume.
        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(merge(nextState.order, {
            volume: ContentUtils.getNumber(nextState.orderVolume),
            fromDate: DateUtils.toDateText(nextState.fromDate),
            toDate: DateUtils.toDateText(nextState.toDate),
            isSingle: true,
            isNewModal: nextState.isNewModal
        }), offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
        return nextState;
    }

    return nextState;
}

function _checkAvailabilityOfDates(nextState) {
    let singlePosition;
    if (nextState.isNewModal) {
        singlePosition = TankStore.getSingleTankPosition(nextState);
    } else {
        singlePosition = TankStore.getSingleTankPosition(nextState.order);
    }
    // validate index in order to not show the error when don't have selected any tank menu item
    if (nextState.singleTankIndex > -1 && !DashboardLayoutStore.isEmpty(singlePosition, DashboardModalStore.getCurrentLayout())) {
        return t('dashboard_notification_tank_position_occupied');
    } else {
        return '';
    }
}

function _recalculateSingleOrderTasks(oldState, nextState) {
    // remove duplication
    nextState.singleTasks = uniqBy(nextState.singleTasks, l => l.date);

    // Remove unneeded packaging tasks
    nextState.singleTasks = filter(nextState.singleTasks, function (task) {
        return DateUtils.isBeforeOrEquals(task.date, DateUtils.toDateText(nextState.toDate)) && DateUtils.isAfterOrEquals(task.date, DateUtils.toDateText(nextState.fromDate));
    });

    return nextState;
}

function _initNewTasksWithConfiguration(nextState, currentSection) {
    if (currentSection === 'BH') {
        // so we don't want to apply configuration beer style to single Brewhouse section
        // because the way that work the single from Brewhouse, is different to Fermenting and Packaging
        // section.
        return nextState;
    }
    // Only into NEW order operation we use the beer style configuration.
    if (nextState.styleBeerSelected) {
        // Remove if exist other task configuration apply before in order to allow re-calculate the new days positions.
        let singleTasks = filter(nextState.singleTasks, task => !task.isConfiguration);

        const conf = ContentUtils.getTankTypeConfiguration(get(nextState, 'tankSelected.type') || currentSection);
        const sectionName = get(conf, 'tankTypeName');
        const configurationTasks = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), task => {
            return task.styleBeerId === +nextState.styleBeerSelected.id && task.typeTank === sectionName;
        }) || [];

        // apply configuration if exist some configuration task
        if (configurationTasks && configurationTasks.length > 0) {
            // get only task dates in order to use later
            const existingDateTask = map(configurationTasks, task => {
                return DateUtils.addDaysTextBasicFormat(nextState.fromDate, task.day - 1);
            });
            // remove default task to avoid duplicated task
            const defaultIconsFiltered = filter(singleTasks, task => existingDateTask.indexOf(task.date) === -1);
            // apply menu item format to single task
            const configurationConcretTasks = toConcreteTask(configurationTasks, nextState.fromDate, DashboardServiceCache[get(conf, 'getMethodIcons')](), get(nextState, 'tankSelected.type'));
            // combined default task with configuration task
            nextState.singleTasks = concat(defaultIconsFiltered, configurationConcretTasks);
            return nextState;
        }
    }

    return nextState;
}

function _recalculateFromToDate(nextState, tankTypeSelected) {
    const {styleBeerSelected, fromDate} = nextState;
    if (styleBeerSelected) {
        if (tankTypeSelected === TYPE_TANK_FERMENTER) {
            nextState.offsetY = 0;
            nextState.toDate = DateUtils.addDays(fromDate, styleBeerSelected.fermenterDays - 1);
        } else if (tankTypeSelected === TYPE_TANK_BRITE_TANK) {
            const newFromDate = DateUtils.addDays(nextState.toDate, -Math.abs(styleBeerSelected.packagingDays - 1));
            nextState.offsetY = DateUtils.getDaysBetween(fromDate, newFromDate); // should need calculate diff
            nextState.fromDate = newFromDate;
        }
        return nextState;
    } else {
        return nextState;
    }
}

function _initMenuItems(nextState, tankSelected, overrideSection = nextState.currentSection) {
    nextState = _updateTankSelected(nextState, tankSelected, overrideSection);
    nextState = _initBeerStyleMenuItems(nextState);

    return nextState;
}

function _updateTankSelected(nextState, tankSelected, overrideSection = nextState.currentSection) {
    // sync tankMenuItems with current section
    nextState = _initTankMenuItems(nextState, overrideSection, tankSelected);
    nextState = _initTankType(nextState, overrideSection);

    return nextState;
}

function _initBeerStyleMenuItems(nextState) {
    let beerStyleMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_beer_style_placeholder'));
    const isNewModal = nextState.isNewModal;
    const beerStyles = isNewModal ? filter(BeerStyleStore.getBeerStyles(), beerStyle => beerStyle.enable === true || beerStyle.enable === undefined) : BeerStyleStore.getBeerStyles();

    beerStyleMenuItems = concat(beerStyleMenuItems, map(beerStyles, (beerStyle, index) => {
        return Object.assign(beerStyle, {
            payload: index + 1,
            text: beerStyle.name,
            locatorId: `modal-order-beer-style-locator-${index}`
        });
    }));
    nextState.beerStyleMenuItems = beerStyleMenuItems;

    return nextState;
}

function _initTankType(nextState, tankType) {
    switch (tankType) {
        case TYPE_TANK_FERMENTER:
            nextState.listedTaskTypeSelected = {type: TYPE_TANK_FERMENTER};
            nextState.listedTaskTypeSelectedIndex = 1;
            nextState.tankType = 1;
            nextState.tankTypeSelectedIndex = 1;
            return nextState;
        case TYPE_TANK_BRITE_TANK:
            nextState.listedTaskTypeSelected = {type: TYPE_TANK_BRITE_TANK};
            nextState.listedTaskTypeSelectedIndex = 2;
            nextState.tankTypeSelectedIndex = 2;
            nextState.tankType = 2;
            return nextState;
        case TYPE_TANK_BREW_HOUSE:
            nextState.listedTaskTypeSelected = {type: TYPE_TANK_BREW_HOUSE};
            nextState.listedTaskTypeSelectedIndex = 3;
            nextState.tankTypeSelectedIndex = 3;
            nextState.tankType = 3;
            return nextState;
        default:
            return nextState;
    }
}

function _initTankMenuItems(nextState, tankType, tankSelected) {
    const nonSelectedItemText = tankType === TYPE_TANK_BREW_HOUSE
      ? t('dashboard_modal_task_menu_item_select_turn')
      : t('dashboard_modal_task_menu_item_select_tank');

    const selectedEmptyTank = getNonSelectedMenuItem(nonSelectedItemText);
    let tanks, tanksAvailables;

    if (nextState.isNewModal) {
        tanks = TankStore.getAvailabilityTanks(nextState.fromDate, nextState.toDate, tankType, null, DashboardModalStore.getCurrentLayout());
        tanksAvailables = filter(tanks, tank => tank.isAvailable);
    } else {
        tanks = TankStore.getAvailabilityTanks(nextState.fromDate, nextState.toDate, tankType, nextState.order.id, DashboardModalStore.getCurrentLayout());
        tanksAvailables = filter(tanks, tank => tank.isAvailable);
    }

    nextState.tankMenuItems = concat(selectedEmptyTank, DashboardModalUtils.toTankMenuItems(tankType, tanksAvailables));

    nextState = _defineSomeTankSelectionAvailable(nextState, tankSelected, tanksAvailables);

    return nextState;
}

function _defineSomeTankSelectionAvailable(nextState, tankSelected, tanksAvailables) {

    const tankMenuItems = get(nextState, 'tankMenuItems');
    const existTankSelected = !!tankSelected;
    const firstTankAvailable = get(tankMenuItems, '1.tankObj');
    const existTankAvailable = get(nextState, 'tankMenuItems.length', 0) > 1;

    if (!existTankAvailable) {
        // enter here means is not longer exist tank available
        // so we clean current tank selected
        nextState = _cleanTankSelected(nextState);
    }

    if (existTankSelected) {
        const tankSelectedId = get(tankSelected, 'id', get(tankSelected, 'tankObj.id'));
        tankSelected.id = tankSelectedId; // need to override because same cases id is not there
        const existTankSelectedInTankMenuItems = !!find(tankMenuItems, menuItem => get(menuItem, 'tankObj.id') === tankSelectedId);

        if (existTankSelectedInTankMenuItems) {
            // remain the same tank selected
            // just update index and selection
            // values in case that are not already defined
            nextState = _setTankSelected(nextState, tankSelected, tanksAvailables);
            return nextState;
        } else {
            nextState = _setTankSelected(nextState, firstTankAvailable, tanksAvailables);
        }

    } else {
        nextState = _setTankSelected(nextState, firstTankAvailable, tanksAvailables);
    }

    return nextState;
}

function _cleanTankSelected(nextState) {
    nextState.singleTank = null;
    nextState.singleTankId = null;
    nextState.singleTankIndex = null;
    nextState.tankSelected = null;
    return nextState;
}

function _setTankSelected(nextState, selectedTank, tanks) {
    // If enter here means that was already cheked the current `selectedTank` as
    // a available, so just add the `isAvailable` = true in order to reflect that.
    if (selectedTank) selectedTank.isAvailable = true;
    
    nextState.singleTank = selectedTank;
    nextState.singleTankId = get(selectedTank, 'id');
    nextState.singleTankIndex = findIndex(tanks, tank => get(selectedTank, 'id') === get(tank, 'id')) + 1; // select the first available from FV;
    nextState.tankSelected = selectedTank;
    return nextState;
}

function isValidForm(state) {
    let messagesError = getInitialStateErrorMessages();
    let isValid = true;

    if (!state.shouldNeedValidate) {
        return {
            isValid,
            messagesError
        };
    }

    if (DateUtils.isAfter(DateUtils.toDateText(state.fromDate), DateUtils.toDateText(state.toDate))) {
        messagesError.fromDateMessageError = t('dashboard_modal_from_date_inline_error');
        isValid = false;
    } else {
        messagesError.fromDateMessageError = _checkAvailabilityOfDates(state);
        messagesError.toDateMessageError = _checkAvailabilityOfDates(state);
        if (messagesError.fromDateMessageError !== '' || messagesError.toDateMessageError !== '') {
            isValid = false;
        }
    }

    if (!state.styleBeerSelected || !get(state, 'styleBeerSelected.id')) {
        messagesError.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error_required');
        isValid = false;
    } else {
        messagesError.styleBeerMessageError = '';
    }

    if (get(state, 'tankMenuItems.length') === 1) {
        messagesError.tankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
        isValid = false;
    } else if (state.singleTankIndex === -1 || !state.singleTank || get(state, 'singleTank.column') === undefined || get(state, 'singleTank.column') < 0) {
        messagesError.tankMessageError = t('dashboard_modal_general_tank_inline_error_required');
        isValid = false;
    } else {
        messagesError.tankMessageError = '';
    }

    if (state.tankTypeSelectedIndex === 0) {
        messagesError.tankTypeMessageError = t('dashboard_modal_general_tank_inline_error_section_required');
        isValid = false;
    } else {
        messagesError.tankTypeMessageError = '';
    }

    const orderVolume = ContentUtils.getNumber(get(state, 'orderVolume', 0));
    const tankVolume = ContentUtils.getNumber(get(state, 'singleTank.volume', 0));

    const brewhouseMessageError = get(state, 'order.brewhouseMessageError');

    if (brewhouseMessageError) {
        messagesError.volumenTankMessageError = brewhouseMessageError;
        isValid = false;
    } else if (get(state, 'messagesError.volumenTankMessageError.length') > 0) {
        isValid = false;
        messagesError.volumenTankMessageError = get(state, 'messagesError.volumenTankMessageError');
    } else if (tankVolume < orderVolume) {
        messagesError.volumenTankMessageError = t('dashboard_notification_volume_capacity_insufficient');
        isValid = false;
    } else {
        messagesError.volumenTankMessageError = '';
    }

    return {
        isValid,
        messagesError
    };
}

function getInitialStateErrorMessages() {
    return {
        toDateMessageError: null,
        fromDateMessageError: null,
        listedTaskTypeMessageError: null,
        styleBeerSelectedMessageError: null,
        tankTypeMessageError: null,
        tankMessageError: null
    };
}




/**
 * Show the DashboardModalNew from the current clicked order.
 */
function openNewSingleOrder(preDefinedOrder) {
    DashboardModalEl.openNewOrder(preDefinedOrder);
}
/**
 * Show the DashboardModalChangefrom the existing clicked order.
 */
function openExistingSingleOrder(existingOrderInfo) {
    DashboardModalEl.openExistingSingleOrder(existingOrderInfo);
}

module.exports = {
    getNewModalState,
    getExistingModalState,
    isValidForm,
    initializeSingleTasksEl,
    onDeleteTask,
    onChangeTask,
    onChangeFromDate,
    onChangeFromDateEditMode,
    onChangeToDate,
    onChangeToDateEditMode,
    onChangeBeerStyle,
    onChangeTaskType: _onChangeTaskType,
    onChangeTank,
    onChangeTankEditMode,
    onChangeVolume,
    onChangeVolumeNew,
    cleanModal,
    openNewSingleOrder,
    openExistingSingleOrder,
    hydratedTasksWithProducts: _hydratedTasksWithProducts
};



/** WEBPACK FOOTER **
 ** ./src/stores/DashboardModalStore/DashboardModalSingleStore/DashboardModalSingleStore.js
 **/